/** 抖音 Cookie 仅存本机，用于绕过服务器 IP 风控 */
const STORAGE_KEY = 'douyin_cookie'

/** 规范化粘贴内容：去掉 Cookie: 前缀、合并换行 */
export function normalizeDouyinCookieInput(raw) {
  let v = String(raw || '').trim()
  if (/^cookie\s*:/i.test(v)) {
    v = v.replace(/^cookie\s*:/i, '').trim()
  }
  return v.replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' ').trim()
}

function readFromStorage(storage) {
  try {
    const v = storage.getItem(STORAGE_KEY)
    return typeof v === 'string' ? v.trim() : ''
  } catch (_) {
    return ''
  }
}

function writeToStorage(storage, value) {
  try {
    if (value) {
      storage.setItem(STORAGE_KEY, value)
      return readFromStorage(storage) === value
    }
    storage.removeItem(STORAGE_KEY)
    return readFromStorage(storage) === ''
  } catch (_) {
    return false
  }
}

export function getDouyinCookie() {
  if (typeof window === 'undefined') return ''
  const fromLocal = typeof localStorage !== 'undefined' ? readFromStorage(localStorage) : ''
  if (fromLocal) return fromLocal
  return typeof sessionStorage !== 'undefined' ? readFromStorage(sessionStorage) : ''
}

/**
 * @returns {{ ok: boolean, empty?: boolean, length?: number, storage?: 'local'|'session', error?: string }}
 */
export function setDouyinCookie(value) {
  const v = normalizeDouyinCookieInput(value)
  if (!v) {
    if (typeof localStorage !== 'undefined') writeToStorage(localStorage, '')
    if (typeof sessionStorage !== 'undefined') writeToStorage(sessionStorage, '')
    return { ok: true, empty: true }
  }

  const errors = []
  if (typeof localStorage !== 'undefined') {
    if (writeToStorage(localStorage, v)) {
      return { ok: true, length: v.length, storage: 'local' }
    }
    errors.push('localStorage 写入失败')
  }
  if (typeof sessionStorage !== 'undefined') {
    if (writeToStorage(sessionStorage, v)) {
      return { ok: true, length: v.length, storage: 'session' }
    }
    errors.push('sessionStorage 写入失败')
  }
  return {
    ok: false,
    error: errors.join('；') || '当前浏览器禁止本地存储，请关闭无痕模式或更换浏览器'
  }
}

export function hasDouyinCookie() {
  return getDouyinCookie() !== ''
}
